import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    timestamp: Number
  }

  connect() {
    if (this.timestampValue > 0) {
      this.intervalId = setInterval(() => {
        this.element.textContent = this.timeago()
      }, 1000)
    }
  }

  disconnect() {
    clearInterval(this.intervalId)
  }

  timeago() {
    const seconds = Math.floor(Date.now() / 1000) - this.timestampValue
    let interval = seconds / 86400
    if (interval > 1) {
      return Math.floor(interval) + 'd ago'
    }
    interval = seconds / 3600
    if (interval > 1) {
      return Math.floor(interval) + 'h ago'
    }
    interval = seconds / 60
    if (interval > 1) {
      return Math.floor(interval) + 'm ago'
    }
    return 'just now'
  }
}
